module.exports = __webpack_public_path__ + "assets/img/binding-3-sm.0ccf3a7a.jpg";